/**
 * Local storage backup for pending read marks
 * Ensures read marks persist across page refreshes
 */

const STORAGE_KEY = 'pending_read_marks';

interface PendingReadMark {
  userId: string;
  timestamp: number;
}

export function addPendingReadMark(conversationId: string, userId: string) {
  const pending = getPendingReadMarks();
  pending[conversationId] = { userId, timestamp: Date.now() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
}

export function getPendingReadMarks(): Record<string, PendingReadMark> {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

export function removePendingReadMark(conversationId: string) {
  const pending = getPendingReadMarks();
  delete pending[conversationId];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
}

export function clearPendingReadMarks() {
  localStorage.removeItem(STORAGE_KEY);
}
